import { useEffect } from 'react';
import useVaultIdParam from '@optimus/State/App/NavigationContext/hooks/useVaultIdParam';
import { useTaskBoardDispatchContext } from '@app/Areas/Optimus/Apps/TaskBoardApp';
import { ARCHIVED_BOARDS_RESET, getArchivedVaultBoards } from '../../../state/TaskBoardReducer/TaskBoardReducer';

function useArchivedBoardsFetch() {
    const vaultId = useVaultIdParam();
    const boardDispatch = useTaskBoardDispatchContext();

    useEffect(() => {
        async function fetchArchivedBoards() {
            if (vaultId) {
                boardDispatch(getArchivedVaultBoards(vaultId));
            }
        }
        fetchArchivedBoards();

        return function cleanup(){
            boardDispatch({ type: ARCHIVED_BOARDS_RESET })
        }
    }, [vaultId]);
}

export default useArchivedBoardsFetch;